module.exports = __webpack_public_path__ + "img/wechat-guide.b5160019.png";